import { Box, SimpleGrid } from '@mantine/core';

import { Collateral } from 'models';

import { CollateralTeaser } from 'components/collateral/CollateralTeaser';
import { TeaserCarousel } from 'components/teaser-carousel/TeaserCarousel';

const CollateralTeaserGrid = ({
    items,
    grid,
}: {
    items: { collateral: Collateral; href: string }[];
    grid?: boolean;
}) => {
    const cards = (layout: 'horizontal' | 'vertical') =>
        items.map(({ collateral, href }) => (
            <CollateralTeaser key={collateral.id} collateral={collateral} href={href} layout={layout} />
        ));

    if (grid) {
        return (
            <SimpleGrid cols={{ base: 2, xs: 3, sm: 4 }} spacing="md">
                {cards('vertical')}
            </SimpleGrid>
        );
    }

    const carousel = <TeaserCarousel>{cards('vertical')}</TeaserCarousel>;

    if (items.length > 2) {
        return carousel;
    }

    return (
        <>
            <SimpleGrid cols={items.length} spacing="md" visibleFrom="md">
                {cards('horizontal')}
            </SimpleGrid>
            <Box hiddenFrom="md">{carousel}</Box>
        </>
    );
};

export { CollateralTeaserGrid };
